import { SwipeableDrawer, drawerClasses, styled } from "@mui/material";
import { toolbarModalDrawerName } from "../classes.js";
const paper = `.${drawerClasses.paper}`;
const Root = styled(SwipeableDrawer, {
  name: toolbarModalDrawerName,
  overridesResolver: (_props, styles) => [styles.root],
  slot: "Root"
})(({ ownerState }) => ({
  [paper]: {
    left: ownerState?.offsetX
  }
}));
export {
  Root
};
//# sourceMappingURL=Root.js.map
